/**
 * FIP API Service
 *
 * Provides typed access to FIP list endpoints.
 */

import { httpClient } from './http-client.service';
import type {
  FipListResponse,
  FipQueryParams,
  FipUpdatePayload,
} from '../types/fip-list';

class FipAPIService {
  /**
   * Fetch paginated list of FIPs.
   */
  async getFips(params: FipQueryParams): Promise<FipListResponse> {
    try {
      const response = await httpClient.get<FipListResponse>('list/fips', {
        params,
      });
      return response.data;
    } catch (error) {
      console.error('[FipAPI] Failed to fetch FIPs:', error);
      throw error;
    }
  }

  /**
   * Update FIP active status.
   */
  async updateFipStatus(payload: FipUpdatePayload): Promise<any> {
    try {
      const response = await httpClient.post('update/list/fips', payload);
      return response.data;
    } catch (error) {
      console.error('[FipAPI] Failed to update FIP status:', error);
      throw error;
    }
  }
}

export const fipAPI = new FipAPIService();
